<template>
    <div class="n-ptb-4">
        <Breadcrumb :data="breadcrumb"></Breadcrumb>

        <div class="n-p-4 c-max-width n-m-auto n-bg-1 c-shadow n-mt-3">
            <div class="n-flex n-bg-1 n-p-4"
                 v-if="loadings">
                <div class="list-thumb  n-flex-s n-mr-3 n-skeleton"></div>
                <div class="n-flex-g n-flex-g-w-1-hack">
                    <div class="n-skeleton n-skeleton-text n-ptb-6"></div>
                    <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-6"></div>
                    <div class="n-skeleton n-skeleton-text n-mt-6"></div>
                </div>
            </div>

            <div class="n-flex book-top"
                 v-else>
                <div class="list-thumb c-border n-flex-s n-mr-3">
                    <NImage class="list-thumb-image n-col-1 n-h-1"
                            type="cover"
                            zoomView
                            :src="data.coverPicture">
                    </NImage>
                </div>
                <div class="n-flex-g n-flex-g-w-1-hack book-info">
                    <h1 class="n-f-bold n-c-4 n-m-0"><span class="n-mr-3 n-inline">{{ data.title || '-' }} - {{ chapter.title || '-' }}</span></h1>
                    <div class="n-flex n-c-4 n-mt-1"
                         v-if="Object.keys(this.bookRelatedPersonGroup).length > 0">
                        <h4 class="n-mb-0 n-flex-s">{{  LAN.common.authorEditor[Object.keys(this.bookRelatedPersonGroup)[0]] + (data.bookRelatedPerson.length > 1 ? 's' : '')  }}:&nbsp;&nbsp;</h4>
                        <ul class="n-ul n-p-0 n-m-0 n-flex n-flex-w">
                            <li v-for="(item, index) in chapter.chapterRelatedPerson"
                                :key="item.name">{{ item.name + ((item.title || '') == '' ? '' : (`(${item.title})`)) }}{{ index < chapter.chapterRelatedPerson.length - 1 ? '、' : '' }}
                            </li>
                        </ul>
                    </div>
                    <!-- 
                    <h4 class="n-c-4 n-mb-0 n-f-normal"
                        v-if="chapter.chapterSeq">
                        <label class="n-flex-s">{{ LAN.common.chapterSeq }}:&nbsp;&nbsp;</label>{{ chapter.chapterSeq || '-' }}
                    </h4> -->

                    <h4 class="n-c-4 n-mb-0 n-f-normal"
                        v-if="chapter.publishDate">
                        <label class="n-flex-s">{{ LAN.common.publishDate }}:&nbsp;&nbsp;</label>{{ chapter.publishDate ? parseCDate(chapter.publishDate) : '-' }}
                    </h4>

                    <span class="n-block n-c-4"
                          v-if="chapter.startPage || chapter.endPage">
                        <label class="n-flex-s">{{ LAN.journal.pages }}:&nbsp;&nbsp;</label>{{ [chapter.startPage, chapter.endPage].join('-') }}
                    </span>

                    <!-- <span class="n-block n-c-4 c-link c-hover n-pointer"
                          v-if="chapter.doi">{{ chapter.doi }}</span> -->

                    <a-button type="primary"
                              class="c-tab-link c-tab-link-event n-mt-2"
                              v-if="auth && chapter && chapter.contentPdf && chapter.contentPdf.originalName"
                              @click="openPDF">{{ LAN.common.PDFAll }}</a-button>
                    <a-button type="primary"
                              class="c-tab-link c-tab-link-event n-mt-2"
                              v-if="!auth && chapter && chapter.contentPdf && chapter.contentPdf.originalName"
                              @click="goContact">{{
            LAN.common.subscribe }}</a-button>
                </div>
            </div>
        </div>

        <div class="c-max-width n-m-auto n-bg-2 n-mt-4 c-tab-tab">
            <a-row :gutter="[20, 10]">
                <a-col :span="24"
                       :lg="18">
                    <div class="n-bg-1 n-p-3"
                         v-if="loadings">
                        <ul class="n-ul n-p-0 list n-bg-1 n-mt-2">
                            <li class="n-pointer n-p-4"
                                v-for="item in 3"
                                :key="item">
                                <div class="n-skeleton n-skeleton-text n-ptb-4 n-col-3"></div>
                                <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>
                                <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>
                                <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>
                            </li>
                        </ul>
                    </div>

                    <div class="n-bg-1 n-p-3"
                         v-else>

                        <div v-if="chapter.chapterRelatedPerson?.length > 0">
                            <h4 class="n-f-6 n-f-bold n-m-0 n-mt-1">{{ LAN.journal.authorInfoA }} </h4>
                            <div class="n-pb-3"
                                 v-if="Object.keys(bookRelatedPersonGroup).length > 0">
                                <div v-for="(item,index) in bookRelatedPersonGroup"
                                     :key="index">
                                    <h4 class="n-f-4 n-f-bold n-line-height-1 n-mt-3">{{ LAN.common.authorEditor[index] + (item.length > 1 ? 's' : '') }}</h4>

                                    <ul class="n-ul n-p-0 n-m-0">
                                        <li v-for="(sItem, sIndex) in item"
                                            :key="sIndex">
                                            {{ sItem.name + ((sItem.title || '') == '' ? '' : (` (${sItem.title})`)) }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div v-if="chapter.detail?.fabstract">
                            <h4 class="n-f-bold n-m-0 n-mt-6 n-f-6">{{ LAN.journal.abstract }}</h4>
                            <div v-html="chapter.detail.fabstract || '-'"></div>
                        </div>

                        <div v-if="chapter.detail?.keywords">
                            <h4 class="n-f-bold n-m-0 n-mt-6 n-f-6">{{ LAN.journal.keyword }}</h4>
                            <div v-html="chapter.detail.keywords || '-'"></div>
                        </div>

                        <div v-if="chapter.detail?.remark">
                            <h4 class="n-f-bold n-m-0 n-mt-6 n-f-6">{{ LAN.journal.remark }}</h4>
                            <div v-html="chapter.detail.remark || '-'"></div>
                        </div>
                    </div>
                </a-col>
                <a-col :span="24"
                       :lg="6">
                    <div class="n-bg-1"
                         v-if="!loadings">
                        <h4 class="n-m-0 n-f-6 n-f-bold n-c-4 n-plr-3 n-ptb-3">
                            {{ LAN.common.tables }}
                        </h4>

                        <div class="left-menu n-scroll-v">
                            <ul class="n-p-0 n-p-1 n-ul n-m-0 c-content-left">
                                <li class="n-mb-4 n-c-4"
                                    v-for="(gItem,gIndex) in data.chapters"
                                    :key="gItem.groupTitle">
                                    <a href="javascript:;"
                                       @click="changeChapterActive(gIndex)"
                                       class="n-f-6 n-p-1 c-tab-link c-tab-link-event n-c-4 n-block"
                                       :class="{'n-active': chapterActive[gIndex] || (gItem.chapters.length > 0 && gItem.groupTitle == 'NA')}"
                                       v-if="gItem.chapters.length > 0 && gItem.groupTitle != 'NA'">
                                        <CaretRightOutlined class="n-mr-1 n-c-2 n-f-6 c-arrow" />{{ gItem.groupTitle }} <span class="n-inline-block n-f-normal n-f-2">({{gItem.chapters.length}})</span>
                                    </a>

                                    <ul v-if="chapterActive[gIndex] || (gItem.chapters.length > 0 && gItem.groupTitle == 'NA')"
                                        class="n-ul n-m-0 n-p-0 n-pl-5 n-mb-2">
                                        <li v-for="item in gItem.chapters"
                                            :key="item.id">

                                            <span v-if="item.id == $route.query.id"
                                                  class="n-block n-mb-1 n-c-UI-blue">
                                                <span v-html="item.title"
                                                      class="c-link"></span>
                                                <EyeOutlined class="n-ml-1"
                                                             style="transform: translateY(2px);"
                                                             v-if="item.chapterType == 'front-matter' || item.chapterType == 'back-matter'" />
                                            </span>

                                            <a :href="`/web/viewer${data.isPdfReadOnly === 1 ? '_noop' : ''}.html?file=` + encodeURIComponent(item.contentPdf.resourceUrl)"
                                               target="_blank"
                                               class="c-tab-link c-tab-link-event n-block n-mb-1 n-c-4"
                                               v-else-if="(item.chapterType == 'front-matter' || item.chapterType == 'back-matter') && data.contentPdfViewType == 'NEW_WINDOW'">
                                                <span v-html="item.title"
                                                      class="c-link"></span>
                                                <EyeOutlined class="n-ml-1"
                                                             style="transform: translateY(2px);"
                                                             v-if="item.chapterType == 'front-matter' || item.chapterType == 'back-matter'" />
                                            </a>

                                            <a href="javascript:;"
                                               class="c-tab-link c-tab-link-event n-block n-mb-1 n-c-4"
                                               v-else-if="(item.chapterType == 'front-matter' || item.chapterType == 'back-matter') && data.contentPdfViewType != 'NEW_WINDOW'"
                                               @click="viewData.url = item.contentPdf.resourceUrl; viewData.title = item.title; viewData.show = true">
                                                <span v-html="item.title"
                                                      class="c-link"></span>
                                                <EyeOutlined class="n-ml-1"
                                                             style="transform: translateY(2px);"
                                                             v-if="item.chapterType == 'front-matter' || item.chapterType == 'back-matter'" />
                                            </a>

                                            <router-link v-else
                                                         class="c-tab-link c-tab-link-event n-block n-mb-1 n-c-4"
                                                         :to="{ name: 'ChapterDetail', query: { id: item.id, bid: $route.query.bid } }">
                                                <span v-html="item.title"
                                                      class="c-link"></span>
                                                <EyeOutlined class="n-ml-1"
                                                             style="transform: translateY(2px);"
                                                             v-if="item.chapterType == 'front-matter' || item.chapterType == 'back-matter'" />
                                            </router-link>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>

                        <!-- <a-collapse :default-active-key="defaultGroup"
                                    :bordered="false">
                            <a-collapse-panel :header="gItem.groupTitle"
                                              :key="gItem.groupTitle"
                                              style="background-color: #fff; padding: 0; border-bottom: 1px #f7f7f7 solid"
                                              v-for="gItem in data.chapters">
                                <ul class="n-ul n-p-0 n-pl-5">
                                    <li v-for="item in gItem.chapters"
                                        :key="item.id"
                                        class="c-link n-mb-4 n-f-6 n-line-height-1-5 n-pointer c-hover">
                                        <a href="javascript:;"
                                           class="c-tab-link c-tab-link-event"
                                           :class="item.id == this.$route.query.id ? 'n-c-UI-blue' : 'n-c-4'"
                                           @click="item.id == this.$route.query.id ? () => { } : push.call(this, {name: 'ChapterDetail', query: {id: item.id, bid:$route.query.bid }})">
                                            <span v-html="item.title"
                                                  class="c-link"></span>
                                            <ArrowRightOutlined class="link-arrow" />
                                        </a>
                                    </li>
                                </ul>
                            </a-collapse-panel>
                        </a-collapse> -->

                    </div>
                </a-col>
            </a-row>
        </div>

        <a-modal v-model:visible="viewData.show"
                 centered
                 width="calc(100vw - 10px)"
                 height="calc(100vh - 10px)"
                 class="pdf-dialog"
                 v-if="viewData.show"
                 :bodyStyle="{padding: 0}"
                 :title="(viewData.title || '-')"
                 :footer="null"
                 @ok="viewData.show = false">
            <DocView v-if="data.isPdfReadOnly !== 1"
                     :url="viewData.url"
                     :name="viewData.title"
                     class="pdf"></DocView>

            <DocViewNoOp v-if="data.isPdfReadOnly === 1"
                         :url="viewData.url"
                         :name="(viewData.title || '-')"
                         class="pdf">
            </DocViewNoOp>
        </a-modal>
    </div>
</template>
<script>
    import { mapMutations, mapState } from 'vuex';
    import { Modal } from 'ant-design-vue'
    import NImage from '@/components/nui/NImage/NImage.vue'
    import DocView from '@/components/nui/DocView/DocView.vue'
    import DocViewNoOp from '@/components/nui/DocView/DocViewNoOp.vue'
    import NEditorParser from '@/components/NEditorParser.vue';
    import Breadcrumb from '@/components/Breadcrumb.vue'
    import { LinkOutlined, CaretRightOutlined, ArrowRightOutlined, EyeOutlined } from '@ant-design/icons-vue';
    import crypto from '@/assets/script/crypto';
    import nui from '@/assets/script';

    export default {
        name: 'ChapterDetail',
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                auth: false,
                authPdf: false,
                viewData: { show: false },


                loadings: false,

                chapterActive: {},
                data: {},
                chapter: {},

                bookRelatedPersonGroup: {}
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat()),

            NMounted () {
                this.loadData()
            },

            checkContentPermission () {
                this.auth = false;

                this.request(this.API.checkContentPermission, {
                    params: { dataid: this.$route.query.id, datatype: "chapter" }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.auth = res.data.hasAuth;
                    }
                })
            },

            checkAuth (callback) {
                if (!this.chapter) {
                    return
                }

                this.request(this.API.pdfCheckAuth, {
                    params: { dataid: this.$route.query.id, datatype: "chapter", name: this.chapter.contentPdf.name }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.auth = res.data.hasAuth;
                        let url = crypto.decrypt(res.data.url);
                        callback && callback(url);
                    }
                })
            },
            openPDF () {
                this.checkAuth((url) => {
                    if ((url || '') == '') {
                        return;
                    }

                    this.viewData.url = url;
                    this.viewData.title = this.chapter.contentPdf.originalName;// this.chapter.title

                    if ((this.data.contentPdfViewType || '') == 'NEW_WINDOW') {
                        window.open(`/web/viewer${this.data.isPdfReadOnly === 1 ? '_noop' : ''}.html?file=` + encodeURIComponent(url), '_blank');
                    } else {
                        this.viewData.show = true;
                    }
                });
            },
            changeChapterActive (index) {
                this.chapterActive[index] = !this.chapterActive[index]
            },
            loadData () {
                this.loadings = true
                this.loadingChapter = true

                if (!this.$route.query.bid) {
                    return;
                }

                this.request(this.API.bookDetail, {
                    params: { id: this.$route.query.bid }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.data = res.data;

                        res.data.chapters.forEach((gItem, gIndex) => {
                            var current = gItem.chapters.filter(item => item.id == this.$route.query.id)[0];

                            if (current) {
                                this.chapter = current
                                this.chapterActive[gIndex] = true
                            }
                        });


                        this.loadings = false;



                        this.chapter.chapterRelatedPerson?.forEach(item => {
                            if (this.bookRelatedPersonGroup[item.relatedType]) {
                                this.bookRelatedPersonGroup[item.relatedType].push(item)
                            } else {
                                this.bookRelatedPersonGroup[item.relatedType] = [item]
                            }
                        })

                        this.breadcrumb = [{ title: res.data.title, url: 'BDetail', query: { from: 'book', id: this.$route.query.bid } }, { title: this.chapter.title }]

                        this.checkContentPermission();
                    }
                }).catch(err => {
                    this.loadings = false
                })
            },
            goContact () {
                this.$router.push({ name: 'contact' })
            }
        }),
        components: {
            NImage,
            DocView,
            DocViewNoOp,
            Breadcrumb,
            LinkOutlined,
            NEditorParser,
            CaretRightOutlined,
            ArrowRightOutlined,
            EyeOutlined
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
    .list-thumb {
        width: 160px;
        height: 230px;

        .list-thumb-image {
            transition: all 0.3s;
        }
    }

    .list-item {
        transition: all 0.3s;

        &:hover {
            box-shadow: $shadow-2;
        }
    }

    .book-introduce {
        table {
            display: table;
        }

        ul {
            display: none;
        }
    }

    @media screen and (max-width: 1100px) {
        .book-introduce {
            table {
                display: none;
            }

            ul {
                display: block;
            }
        }

        .book-top {
            display: block;

            .book-info {
                margin-top: 15px;
                width: auto;
            }
        }
    }
</style>
<style lang="scss">
    .pdf-dialog {
        max-width: 100% !important;

        .ant-modal-header {
            background: rgba(56, 56, 61, 1);
            padding: 10px;
            height: 40px;
            border-bottom: 0;
        }

        .ant-modal-title {
            color: $font-color-1;
        }

        .ant-modal-close-x {
            color: $font-color-1;
            width: 40px;
            height: 40px;
            line-height: 40px;
        }

        .ant-modal-content {
            height: 100%;
        }

        .ant-modal-body {
            height: calc(100% - 40px);
        }
    }

    .left-menu {
        li {
            transition: all 0.3s;

            &:hover {
                color: $color-base;
            }

            &.n-selected {
                background-color: $background-red;
                color: $color-base;

                &:after {
                    background-color: $background-red;
                }
            }

            a.n-active {
                .c-arrow {
                    transform: rotate(90deg);
                }
            }
        }
    }

    .link-arrow {
        position: relative;
        top: 1px;
        font-size: 12px;
    }
</style>